import React, { useState } from "react";
import "./QuestionsAnswers.css";
import classNames from "../../../utils/classNames";

const questions = [
  {
    question: "Why is the course ten days long?",
    answer:
      "Actually, the ten-day course is the minimum; it provides an essential introduction and foundation to the technique. To develop in the practice is a lifetime job. Experience over generations has shown that if Vipassana is taught in periods of less than ten days, the student does not get a sufficient experiential grasp of the technique. Traditionally, Vipassana was taught in retreats lasting seven weeks. With the dawning of the 20th century, the teachers of this tradition began to experiment with shorter times to suit the quickening pace of life. They tried thirty days, two weeks, ten days, down to seven days--and they found that less than ten days is not enough time for the mind to settle down and work deeply with the mind-body phenomenon.",
  },
  {
    question: "How many hours a day will I be meditating?",
    answer:
      "The day begins at 4:00 a.m. with a wakeup bell and continues until 9:00 p.m. There are about ten hours of meditation throughout the day, interspersed with regular breaks and rest periods. Every evening at 7:00 p.m. there is a videotaped lecture by the Teacher, S.N. Goenka, which provides a context for meditators to understand their experience of the day.",
  },
  {
    question: "What language is used in the course?",
    answer:
      "The teaching is given through recordings of S.N. Goenka, speaking in English or Hindi, together with a translation into a local language. Tape translations exist in most of the major languages of the world, including English. If the teachers conducting a course do not speak the local language fluently, interpreters will be there to help. Language is usually no barrier for someone who wants to join a course.",
  },
  {
    question: "How much does the course cost?",
    answer:
      "Each student who attends a Vipassana course is given this gift by a previous student.There is no charge for either the teaching, or for room and board. All Vipassana courses worldwide are run on a strictly voluntary donation basis. At the end of your course, if you have benefited from the experience, you are welcome to donate for the coming course, according to your volition and your means.",
  },
  {
    question: "How much are teachers paid to conduct courses",
    answer:
      "Teachers receive no payment, donations or other material benefit. They are required to have their own private means of support. This rule means that some of them may have less time for teaching, but it protects students from exploitation and it guards against commercialism. In this tradition, teachers give Vipassana purely as a service to others.All they get is the satisfaction of seeing people's happiness at the end of ten days.",
  },
  {
    question: "I can’t sit cross-legged. Can I meditate?",
    answer:
      "Certainly. Chairs are provided for those unable to sit comfortably on the floor because of age or a physical problem.",
  },
  {
    question: "I’m on a special diet. Can I bring my own food",
    answer:
      "If your doctor has prescribed a special diet, let us know and we will see whether we can provide what you need. If the diet is too specialized or would interfere with meditation, we might have to ask you to wait until you can be more flexible. We're sorry but students are required to choose from the food provided to them, rather than bring food for themselves. Most people find the choice is ample and they enjoy the simple vegetarian diet.",
  },
  {
    question:
      "Can pregnant women attend courses? Are there any special arrangements or instructions for them?",
    answer:
      "Pregnant women may certainly attend, and many women come specifically during pregnancy to take advantage of the opportunity to work deeply and in silence during this special time. We ask pregnant women to ensure they are confident that their pregnancy is stable before applying. We provide the extra food they need and ask them to work in a relaxed way.",
  },
  {
    question: "Why is a course conducted in silence?",
    answer:
      'All students attending the course observe "noble silence" — that is, silence of body, speech and mind.They agree to refrain from communicating with their co-meditators. However, students are free to contact the management about their material needs, and to speak with the instructor. Silence is observed for the first nine full days. On the tenth day, speech is resumed as a way of re-establishing the normal pattern of daily life. Continuity of practice is the secret of success in this course; silence is an essential component in maintaining this continuity.',
  },
  {
    question: "How can I be sure I am capable of doing meditation?",
    answer:
      "For a person in reasonable physical and mental health who is genuinely interested and willing to make a sincere effort, meditation (including 'noble silence') is not difficult. If you are able to follow the instructions patiently and diligently, you can be sure of tangible results. Though it may appear daunting, the day's schedule is neither too severe nor too relaxed. Moreover, the presence of other students practicing conscientiously in a peaceful and conducive atmosphere lends tremendous support to one's efforts.",
  },
  {
    question: "Is there anyone who should not participate in a course?",
    answer:
      "Obviously someone who is physically too weak to follow the schedule will not be able to benefit from a course.The same is true of someone suffering from psychiatric problems, or someone undergoing emotional upheaval. Through a process of questions and answers, we will be able to help you decide clearly beforehand whether you are in a position to benefit fully from a course. In some cases applicants are asked to get approval from their doctor before they can be accepted.",
  },
  {
    question: "Can Vipassana cure physical or mental diseases?",
    answer:
      "Many diseases are caused by our inner agitation. If the agitation is removed, the disease may be alleviated or disappear. But learning Vipassana with the aim of curing a disease is a mistake that never works. People who try to do this waste their time because they are focusing on the wrong goal. They may even harm themselves. They will neither understand the meditation properly nor succeed in getting rid of the disease.",
  },
  {
    question: "How about depression? Does Vipassana cure that?",
    answer:
      "Again, the purpose of Vipassana is not to cure diseases. Someone who really practices Vipassana learns to be happy and balanced in all circumstances. But a person with a history of severe depression may not be able to apply the technique properly and may not get the desired results. The best thing for such a person is to work with a health professional. Vipassana teachers are meditation experts, not psychotherapists.",
  },
  {
    question: "Can Vipassana make people mentally unbalanced?",
    answer:
      "No. Vipassana teaches you to be aware and equanimous, that is, balanced, despite all the ups and downs of life. But if someone comes to a course concealing serious emotional problems, that person may be unable to understand the technique or to apply it properly to achieve the desired results. This is why it is important to let us know your past history so that we can judge whether you will benefit from a course.",
  },
  {
    question: "Do I have to be a Buddhist to practice Vipassana?",
    answer:
      "People from many religions and no religion have found the meditation course helpful and beneficial. Vipassana is an art of living, a way of life. While it is the essence of what the Buddha taught, it is not a religion; rather, it is the cultivation of human values leading to a life which is good for oneself and good for others.",
  },
  {
    question: "Why do I have to stay for the entire ten days?",
    answer:
      "Vipassana is taught step by step, with a new step added each day to the end of the course. If you leave early, you do not learn the full teaching and do not give the technique a chance to work for you. Also, by meditating intensively, a course participant initiates a process that reaches fulfillment with the completion of the course. Interrupting the process before completion is not advisable.",
  },
  {
    question: "Is it dangerous to leave a course early?",
    answer:
      "The point is that leaving early is shortchanging yourself. You don't give yourself a chance to learn the full technique and so you won't be able to apply it successfully in daily life. You also interrupt the process in the middle rather than letting it come to the proper conclusion. To get home a day or two early, you waste all the time you have invested.",
  },
  {
    question:
      "How about the tenth day, when talking is allowed and serious meditation stops? Can I leave then?",
    answer:
      "The tenth day is a very important transition back to ordinary life. No one is permitted to leave on that day.",
  },
];

const QuestionsAnswers = () => {
  return (
    <div className="container custom-container custom-container-three-pages mb-5">
      <h5 className="mb-5 mt-5 text-center">Questions & answers</h5>
      <dl className="">
        {questions.map((q, index) => (
          <QuestionAnswer key={index} question={q.question} answer={q.answer} />
        ))}
      </dl>
    </div>
  );
};

const QuestionAnswer = ({ question, answer }) => {
  const [isOpened, setIsOpened] = useState(false);

  const onClick = () => setIsOpened(!isOpened);

  return (
    <div className="questionAnswerContainer" onClick={onClick}>
      <div className="questionAnswerTitleContainer">
        <dt className="questionAnswerTitle">{question}</dt>
        <div className="questionAnswerIcon">
          {isOpened ? <MinusIcon /> : <PlusIcon />}
        </div>
      </div>
      <dd
        className={classNames(
          !isOpened && "hidden",
          "questionAnswerDescription body1",
        )}
      >
        {answer}
      </dd>
    </div>
  );
};

const PlusIcon = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      width="24px"
      height="24px"
      color="#ffc107"
    >
      <path d="M12 4.5v15m7.5-7.5h-15" />
    </svg>
  );
};

const MinusIcon = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="size-6"
      width="24px"
      height="24px"
      color="#ffc107"
    >
      <path d="M5 12h14" />
    </svg>
  );
};

export default QuestionsAnswers;
